import React, { useCallback } from 'react';

import classNames from 'classnames';

import CheckSymbol from '@travauxlib/shared/src/components/DesignSystem/assets/CheckSymbolFilled.svg?react';

import { ActionListIconContainer } from './ActionListIconContainer';
import { OptionItemType } from './type';
import { determineBgColor } from './utils/styleHelper';

type OptionItemProps = {
  closeActionList?: () => void;
  small?: boolean;
} & OptionItemType;

export const OptionItem: React.FC<OptionItemProps> = ({
  disabled,
  label,
  onChange,
  closeActionList,
  value,
  small,
  active,
  selected,
}) => {
  const refinedOnClick = useCallback(() => {
    onChange(!value);
    closeActionList?.();
  }, [onChange, closeActionList, value]);

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={refinedOnClick}
      className={classNames(
        'flex items-center py-xs pr-sm pl-[0.85rem] hover:action-bg-neutral-hover active:action-bg-neutral-pressed w-full',
        determineBgColor(selected, active),
        {
          'action-bg-neutral-disabled text-disabled hover:action-bg-neutral-disabled active:action-bg-neutral-disabled':
            disabled,
        },
      )}
    >
      <ActionListIconContainer
        small={small}
        className="icon-success-strong mr-xs"
        disabled={disabled}
      >
        {value && <CheckSymbol />}
      </ActionListIconContainer>
      <span
        className={classNames('whitespace-nowrap text-b2', {
          'text-b3': small,
        })}
      >
        {label}
      </span>
      <ActionListIconContainer small={small} />
    </button>
  );
};
